module.exports = __webpack_public_path__ + "img/4.5f17c9ba.png";